import { render, staticRenderFns } from "./TaskProps.vue?vue&type=template&id=4b9f509a&scoped=true&"
import script from "./TaskProps.vue?vue&type=script&lang=ts&"
export * from "./TaskProps.vue?vue&type=script&lang=ts&"
import style0 from "./TaskProps.vue?vue&type=style&index=0&id=4b9f509a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9f509a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VDivider,VImg})
